export default {
      id: "huge-user-plus-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.25bf3227.svg#huge-user-plus",
      toString: function () {
        return this.url;
      }
    }